// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as PlUtils from "../player/PlUtils.bs.js";
import * as HelpIcon from "../player/HelpIcon.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
import Close from "@mui/icons-material/Close";

function PlStats$ContestedDescription(Props) {
  return React.createElement("div", {
              className: "leading-normal"
            }, React.createElement("div", undefined, "\"Contested\" shows how contested the units you are playing in your games are, in comparison to expectation based on stats in your region at your rank."), React.createElement("div", {
                  className: "pt-2"
                }, "It shows your ability to scout what compositions your opponents are making and adapt to that by finding uncontested options."), React.createElement("div", {
                  className: "pt-2"
                }, "100% is the expected rate of \"contested\" if you and no one in your game is adjusting to what each other is building. Lower is better."), React.createElement("div", {
                  className: "pt-2"
                }, "It's one of the parameters used to determine player's flexibility rating."));
}

var ContestedDescription = {
  make: PlStats$ContestedDescription
};

function PlStats(Props) {
  var matches = Props.matches;
  var flexibility = Props.flexibility;
  var isDuo = Props.isDuo;
  var set = TftSet.use(undefined);
  var match = React.useState(function () {
        return false;
      });
  var setShowContestedModal = match[1];
  var top1 = Global.f(Belt_Array.keep(matches, (function (p) {
              if (p.queueId === 1150 || p.queueId === 1160) {
                return p.info.placement <= 2;
              } else {
                return p.info.placement === 1;
              }
            })).length) / Global.f(matches.length) * 100;
  var top4 = Global.f(Belt_Array.keep(matches, (function (p) {
              return p.info.placement <= 4;
            })).length) / Global.f(matches.length) * 100;
  var avgPlace = Global.f(Belt_Array.reduce(matches, 0, (function (acc, p) {
              return acc + (
                      isDuo ? (p.info.placement + 1 | 0) / 2 | 0 : p.info.placement
                    ) | 0;
            }))) / Global.f(matches.length);
  var avgTeamCost = Global.f(Belt_Array.reduce(Belt_Array.map(matches, (function (p) {
                  return PlUtils.calcBoardValue(p.info.units, set);
                })), 0, (function (acc, v) {
              return acc + v | 0;
            }))) / Global.f(matches.length);
  var participantsWithUnits = Belt_Array.keep(matches, (function (p) {
          return p.info.units.length !== 0;
        }));
  var avgStarLevel = Belt_Array.reduce(Belt_Array.map(participantsWithUnits, (function (p) {
              return Global.f(Belt_Array.reduce(Belt_Array.map(p.info.units, (function (u) {
                                    return u.tier;
                                  })), 0, (function (acc, v) {
                                return acc + v | 0;
                              }))) / Global.f(p.info.units.length);
            })), 0, (function (acc, v) {
          return acc + v;
        })) / Global.f(participantsWithUnits.length);
  var avgLvl = Global.f(Belt_Array.reduce(matches, 0, (function (acc, hero) {
              return acc + hero.info.level | 0;
            }))) / Global.f(matches.length);
  var avgPlayerDamage = Global.f(Belt_Array.reduce(matches, 0, (function (acc, v) {
              return acc + v.info.totalDamageToPlayers | 0;
            }))) / Global.f(matches.length);
  return React.createElement("div", {
              className: "font-montserrat"
            }, React.createElement("div", {
                  className: "flex justify-between text-[13px] sm:text-[14px] leading-[26px]"
                }, React.createElement("div", {
                      className: "flex"
                    }, React.createElement("div", {
                          className: "font-medium flex flex-col"
                        }, React.createElement("div", undefined, "Games"), React.createElement("div", undefined, "Place"), React.createElement("div", undefined, "Top 4"), React.createElement("div", undefined, "Win"), React.createElement("div", undefined, "Avg. lvl")), React.createElement("div", {
                          className: "flex flex-col items-end font-semibold pl-3 xl:pl-4 text-[14px] sm:text-[16px]"
                        }, React.createElement("div", undefined, String(matches.length)), React.createElement("div", undefined, avgPlace.toFixed(2)), React.createElement("div", undefined, top4.toFixed() + "%"), React.createElement("div", undefined, top1.toFixed() + "%"), React.createElement("div", undefined, avgLvl.toFixed(2)))), React.createElement("div", {
                      className: "pl-8 xl:pl-10 flex"
                    }, React.createElement("div", {
                          className: "font-medium flex flex-col"
                        }, React.createElement("div", undefined, "Avg. damage"), React.createElement("div", undefined, "Avg. eliminated"), React.createElement("div", undefined, "Avg. star level"), React.createElement("div", undefined, "Avg. team cost"), React.createElement("div", {
                              className: "flex"
                            }, "Contested", React.createElement(Tooltip, {
                                  enterDelay: 150,
                                  title: React.createElement(PlStats$ContestedDescription, {}),
                                  children: React.createElement("span", {
                                        className: "ml-1",
                                        onClick: (function (param) {
                                            return Curry._1(setShowContestedModal, (function (param) {
                                                          return true;
                                                        }));
                                          })
                                      }, React.createElement(HelpIcon.make, {
                                            size: 16
                                          }))
                                }))), React.createElement("div", {
                          className: "flex flex-col font-semibold items-end pl-2 xl:pl-4 text-[14px] sm:text-[16px]"
                        }, React.createElement("div", undefined, avgPlayerDamage.toFixed()), React.createElement("div", undefined, T.renderStageNumber(T.fromPvpStage(Math.round(Global.f(Belt_Array.reduce(matches, 0, (function (acc, hero) {
                                                    return acc + T.toPvpStage(hero.info.lastRound) | 0;
                                                  }))) / Global.f(matches.length)) | 0))), React.createElement("div", undefined, avgStarLevel.toFixed(2)), React.createElement("div", undefined, avgTeamCost.toFixed(1)), React.createElement("div", {
                              className: "ml-[-2px]"
                            }, Global.formatPct(undefined, 1 - flexibility) + "%")))), React.createElement(Modal, {
                  BackdropProps: {
                    className: CssJs.style([CssJs.important(CssJs.backgroundColor(CssJs.rgba(0, 0, 0, {
                                        NAME: "num",
                                        VAL: 0.6
                                      })))])
                  },
                  className: "flex items-center justify-center",
                  open: match[0],
                  onClose: (function (param) {
                      return Curry._1(setShowContestedModal, (function (param) {
                                    return false;
                                  }));
                    }),
                  children: React.createElement("div", {
                        className: CssJs.style([
                              CssJs.position(CssJs.relative),
                              CssJs.outline(CssJs.zero, CssJs.solid, CssJs.black)
                            ])
                      }, React.createElement("div", {
                            className: "absolute right-[25px] top-[16px] cursor-pointer",
                            onClick: (function (param) {
                                return Curry._1(setShowContestedModal, (function (param) {
                                              return false;
                                            }));
                              })
                          }, React.createElement(Close, {})), React.createElement(ContentSection.make, {
                            level: 0,
                            className: "max-w-[600px]",
                            title: "Contested",
                            children: React.createElement(PlStats$ContestedDescription, {})
                          }))
                }));
}

var make = React.memo(PlStats);

export {
  ContestedDescription ,
  make ,
  
}
/* make Not a pure module */
